<template>
  <section id="contact" class="contact">

    <section-background clazz="background__contact"/>

    <div class="container contact__container text-white">
      <div class="row contact__headline">
        <h2 class="contact__title text-uppercase">Come for coffee_</h2>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-lg-5 col-sm-10 contact__info py-2 text-uppercase">
          <p>email</p>
          <p class="text-right">info@vitrix.cz</p>
          <p>phone</p>
          <p class="text-right">+420 724 122 085</p>


          <p>Made with <i class="fas fa-heart text-yellow"></i> in Prague</p>
        </div>
      </div>
      <footer class="text-right">
        Designed and created by <a href="//www.7interactive.cz" target="_blank" class="text-yellow">7 Interactive, s.r.o.</a>
      </footer>
    </div>
  </section>
</template>

<script>
  import backgroundComponent from './background'

  export default {
    name: 'Contact-area',
    components: {
      'sectionBackground': backgroundComponent
    }
  }
</script>

<style lang="scss">

  @import "../styles/custom";

  .contact {
    min-height: 100vh;
    position: relative;

    padding: 150px 0;

    &__headline {

    }

    &__title {
      font-size: 86px;
      @include mobile {
        font-size: 43px;
        margin-bottom: 2rem;
      }
    }

    &__info {
      border-left: 6px $yellow solid;
      font-size: 42px;

      p {
        margin: 0;
        line-height: 1;

        &.text-right {
          margin-bottom: 64px;
          margin-top: -8px;
        }
      }

      @include mobile {
        font-size: 21px;

        p{
          &.text-right {
            margin-top: 0;
          }
        }
      }
    }

    &__image {
      @include mobile {
        width: 60vw;
      }
    }

    footer {
      margin-top: 15rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ContactArea.vue